import { AsyncAjaxPost } from "components/Common/AsyncAjaxService";
import { json } from "stream/consumers";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";

const AIApi = {
    root: "https://as-blogai-api-eus-staging-ewazcnfdg8avdcdq.eastus-01.azurewebsites.net/api/v1",
    generateContent:"aiblogs/generateblogpost",
    editContent:"aiblogs/editcontent",

}

export const AITones =  {

professional:"professional",
casual:"casual",
uplifting:"uplifting",
insperation:"inspirational",
trendy:"trendy",
caring:"caring",
motivational:"motivational",
energetic:"energetic"
}





export function BlogAIFormat(rewrite:boolean, content:string,tone:string,prompt:string, group:string,countryCode:number,businessName:string, userContext:UserContext, onComplete:(result:string)=>void,onError:(data:any)=>void){
  
    let cString = "US"

    switch(countryCode){
        case 1:
            cString = "US";
            break;
        case 2:
            cString = "UK";
            break;
        case 3:
            cString = "CA";
            break;
        case 4:
            cString = "AU";
            break;
        
    }

    if(!content || content.trim().length == 0){
        content = "no-content";

    }
  

    const generateBody =(rewrite)?{
        "BusinessName":businessName,
        "VagaroUrl":userContext.vgurl,
        "CountryCode":cString,
        "Tone":tone,
       
        "content":content,
        "Instructions":prompt,
        "merchantId" : userContext.businessId
    }:
      {
        "BusinessName":businessName,
        "VagaroUrl":userContext.vgurl,
        "CountryCode":cString,
        "Tone":tone,
        "Instructions":prompt,
        "merchantId" : userContext.businessId,
    

      }


      let url = (rewrite)?AIApi.editContent:AIApi.generateContent;

      AsyncAjaxPost(url,JSON.stringify(generateBody),userContext.accessToken,(data:any)=>{

        if(data.errors){
            onError(data.errors);
        }
        else if(data?.data?.data?.content)
          onComplete(data.data.data.content);
          else{
              onError(data);
          }
      },(err:any)=>{
            onError(err);
      })



}

